import React, { useState, useEffect } from 'react'
import VisualizacaoPadrao from '../../../../components/VisualizacaoPadrao'
import { useParams } from "react-router-dom";
import { visualizar } from '../../../../util/AcessoApi'

const Visualizacao = (props) => {
    let { id } = useParams();
    const [dados, setDados] = useState()

    useEffect(() => {
        visualizar('/faturamento/cooperadopj', id,
            obj => {
                setDados(obj.id ? {
                    id,
                    modulo: props.modulo,
                    titulo: 'Visualização de Cooperado PJ',
                    grupos: [
                        {
                            titulo: 'Dados Gerais',
                            colunas: [
                                { titulo: 'Código', descricao: obj.id, tamanho: 'col-lg-4' },
                                { titulo: 'Razão Social', descricao: obj.razao_social, tamanho: 'col-lg-4' },
                                { titulo: 'Nome de Fantasia', descricao: obj.nome_fantasia, tamanho: 'col-lg-4' },
                                { titulo: 'Telefone', descricao: obj.telefone, tamanho: 'col-lg-4' },
                                { titulo: 'Fax', descricao: obj.fax, tamanho: 'col-lg-4' },
                                { titulo: 'Número do CNPJ', descricao: obj.cnpj, tamanho: 'col-lg-4' },
                                { titulo: 'E-mail', descricao: obj.email, tamanho: 'col-lg-4' },
                                { titulo: 'Gerente Administrativo', descricao: obj.gerente_administrativo, tamanho: 'col-lg-4' },
                                { titulo: 'Gerente Financeiro', descricao: obj.gerente_financeiro, tamanho: 'col-lg-4' },
                                { titulo: 'Atividade Econômica', descricao: obj.atividade_economica?.label, tamanho: 'col-lg-4' },
                                { titulo: 'Inscrição Municipal', descricao: obj.inscricao_municipal, tamanho: 'col-lg-4' },
                                { titulo: 'Inscrição Estadual', descricao: obj.inscricao_estadual, tamanho: 'col-lg-4' },
                                { titulo: 'E-mail envio Nota Fiscal', descricao: obj.email_envio_nota_fiscal, tamanho: 'col-lg-4' },
                                { titulo: 'CNES', descricao: obj.cnes, tamanho: 'col-lg-4' },
                                { titulo: 'Código da Operadora (ANS)', descricao: obj.codigo_operadora, tamanho: 'col-lg-4' },
                                { titulo: 'Data Admissão', descricao: obj.data_admissao, tamanho: 'col-lg-4' },
                                { titulo: 'Pessoa Jurídica Tipo', descricao: obj.pessoa_juridica_tipo?.label, tamanho: 'col-lg-4' }
                            ]
                        }
                    ]
                } : { titulo: 'Visualização de Cooperado PJ' })
            })
    }, [id])

    return dados ? <VisualizacaoPadrao data={dados} {...props} /> : null
}

export default Visualizacao